import React, { PureComponent as Component } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Toolbars as ToolBarContainer } from '../../../../components/Card/CardHeaderWithToolbars'

export default class Toolbars extends Component {
  render(){
    return(
      <ToolBarContainer>
        <Link 
          to={'/product_variants/create'} 
          className="btn btn-sm btn-primary with-toolbars__toolbars__btn" 
          title="Create new variant"
          target="_blank"
        >
          <i className="fa fa-plus"></i>
        </Link>
        <Button 
          title="Bulk upload"
          color="success"
          className="with-toolbars__toolbars__btn"
          size="sm"
          onClick={this.props.onToggleModalBulkUpload}
          > 
          <i className="fa fa-upload"></i>
        </Button>
        <Button
          title="Export to CSV"
          color="secondary"
          className="with-toolbars__toolbars__btn"
          size="sm"
          disabled={this.props.exporting}
          onClick={this.props.onOpenExport}
          >
          <i className={classNames('fa', {'fa-download':!this.props.exporting,'fa-spinner fa-spin':this.props.exporting})}></i>
        </Button>
        <Button
          title="Refresh"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="info"
          onClick={this.props.onRefreshList}> 
          <i className="fa fa-refresh"></i>
        </Button>
        <Button 
          title="Reset filter"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="warning"
          onClick={this.props.onResetFilter}> 
          <i className="fa fa-ban"></i>
        </Button>
        <Button 
          title="Search and Filter Data"
          size="sm"
          className={classNames("with-toolbars__toolbars__btn",{"btn-danger":this.props.isOpen})} 
          onClick={this.props.onToggleFilter}> 
          <i className={classNames("fa",{"fa-sliders":!this.props.isOpen, "fa-minus":this.props.isOpen})}></i>
        </Button>
      </ToolBarContainer>
    )
  }
}

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onOpenExport: propTypes.func,
  exporting: propTypes.bool,
  onToggleModalBulkUpload: propTypes.func,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func
}
Toolbars.defaultProps = {
  isOpen: false
}